import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-campaign-reject-modal',
    templateUrl: './campaign-reject-modal.component.html',
    styleUrls: ['./campaign-reject-modal.component.scss']
})
export class CampaignRejectModalComponent {
    constructor(
        public dialogRef: MatDialogRef<CampaignRejectModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
